module.exports = __webpack_public_path__ + "assets/img/141.3b339470.png";